var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlutenFree = function SvgGlutenFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GlutenFree_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#GlutenFree_svg__b)",
    d: "M21.978.498c-11.578 0-21 9.418-21 21s9.418 21 21 21 21-9.422 21-21-9.423-21-21-21m0 39.752c-4.718 0-9.024-1.765-12.324-4.654l4.004-4.01a1.12 1.12 0 0 0 0-1.59 1.12 1.12 0 0 0-1.59 0l-4.014 4.017c-2.99-3.321-4.828-7.704-4.828-12.515 0-10.339 8.413-18.751 18.752-18.751 4.81 0 9.189 1.837 12.515 4.828l-3.941 3.945a1.12 1.12 0 0 0 0 1.59 1.115 1.115 0 0 0 1.587 0l3.932-3.936c2.89 3.3 4.654 7.602 4.654 12.324 0 10.339-8.413 18.752-18.751 18.752z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#GlutenFree_svg__c)",
    d: "M17.384 11.572h.013a.91.91 0 0 0 .912-.925V8.895a.9.9 0 0 0-.577-.86.91.91 0 0 0-1.022.22.92.92 0 0 0-.255.636v1.773c.03.599.488.908.93.908"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#GlutenFree_svg__d)",
    d: "M28.185 25.375a.9.9 0 0 0-.785-.068c-.038.017-1.001.377-2.13 1.03-.958.556-1.752 1.15-2.367 1.774v-2.079a3.07 3.07 0 0 0 2.507-.004c.93-.407 1.761-1.239 2.47-2.47.615-1.064.929-2.523.929-4.34 0-1.247-.149-2.176-.157-2.222V13.63a.927.927 0 0 0-1.6-.623.9.9 0 0 0-.25.632v2.762c-.386.17-.887.407-1.527.776-.968.56-1.76 1.154-2.368 1.773v-.602a3.13 3.13 0 0 0 1.574-1.141c.598-.819.904-1.952.904-3.373 0-1.247-.45-2.626-1.366-4.217a16 16 0 0 0-1.116-1.688V4.854a.923.923 0 1 0-1.845.004v3.08c-.2.267-.632.844-1.116 1.684-.904 1.57-1.366 2.987-1.366 4.217 0 1.422.305 2.554.908 3.373.415.564.946.946 1.574 1.137v.607c-.607-.62-1.4-1.214-2.368-1.774-.64-.369-1.154-.61-1.527-.78v-2.758a.92.92 0 0 0-.577-.861.91.91 0 0 0-1.018.22.9.9 0 0 0-.25.641l.008 3.275s-.17.985-.17 2.308c0 1.812.314 3.271.93 4.336.704 1.213 1.557 2.07 2.477 2.473.827.357 1.706.365 2.499 0v2.08c-.747-.765-1.659-1.371-2.367-1.774a15 15 0 0 0-2.122-1.027.92.92 0 0 0-1.022.25 1 1 0 0 0-.22.463 15.6 15.6 0 0 0-.175 2.359c0 1.811.314 3.266.93 4.331.708 1.23 1.544 2.062 2.473 2.47.831.36 1.71.36 2.503.008v1.824a.91.91 0 0 0 .925.912c.445 0 .903-.314.925-.925v-1.816c.793.353 1.671.353 2.503-.008.929-.407 1.76-1.239 2.473-2.473.615-1.065.93-2.52.93-4.332a15.5 15.5 0 0 0-.175-2.359.93.93 0 0 0-.45-.649zm-7.144 7.105c-.047.438-.25.751-.615.96-.365.211-.743.224-1.137.05-.543-.237-1.116-.84-1.613-1.697-.56-.967-.682-2.392-.682-3.41 0-.353.012-.624.025-.845q.342.174.742.399c1.226.704 2.18 1.54 2.618 2.295.496.857.73 1.655.662 2.244zm0-9.155c-.047.442-.242.747-.624.963-.356.208-.73.23-1.128.051-.314-.135-.942-.538-1.613-1.7-.445-.773-.687-1.986-.678-3.412 0-.352.012-.623.025-.84.187.093.416.217.734.395.887.513 2.062 1.323 2.622 2.3.496.856.73 1.654.662 2.243m1.875.005c-.068-.59.17-1.388.662-2.249.182-.318.445-.64.772-.95.509-.484 1.077-.895 1.845-1.34.327-.187.552-.31.738-.404.013.22.022.488.026.84 0 1.464-.233 2.639-.679 3.411-.496.861-1.069 1.468-1.612 1.701-.39.17-.78.153-1.141-.05a1.2 1.2 0 0 1-.611-.96m.624-9.486c0 .988-.196 1.798-.548 2.278-.263.352-.581.517-1.01.517-.428 0-.755-.17-1.013-.517-.353-.484-.548-1.29-.548-2.274 0-1.197.7-2.58 1.116-3.297.195-.326.331-.543.446-.717.118.183.258.4.445.717.416.722 1.116 2.109 1.116 3.297zm3.415 14.538c.004.832-.08 2.38-.675 3.411-.666 1.154-1.298 1.562-1.612 1.697-.403.174-.776.157-1.141-.05-.365-.209-.564-.527-.611-.96-.068-.585.17-1.382.666-2.244q.273-.472.776-.95c.62-.59 1.34-1.056 1.837-1.345.327-.178.552-.301.743-.399.012.217.025.471.025.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#GlutenFree_svg__e)",
    d: "M26.707 11.571h.012a.91.91 0 0 0 .912-.925V8.898a.905.905 0 0 0-.572-.86.93.93 0 0 0-1.281.857v1.768c.03.598.483.908.929.908"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GlutenFree_svg__b",
    x1: 11.478,
    x2: 39.478,
    y1: 0.498,
    y2: 42.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GlutenFree_svg__c",
    x1: 16.919,
    x2: 19.439,
    y1: 7.963,
    y2: 9.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GlutenFree_svg__d",
    x1: 18.572,
    x2: 40.288,
    y1: 3.918,
    y2: 17.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GlutenFree_svg__e",
    x1: 26.241,
    x2: 28.759,
    y1: 7.967,
    y2: 9.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "GlutenFree_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.978.498h42v42h-42z"
  })))));
};
export default SvgGlutenFree;